/**
 * @author Rumyantsev Daniil - 15.08.2017
 */
import {AfterViewInit, Component, OnInit, ViewEncapsulation} from "@angular/core";
import {HttpService} from "../../_service/http.service";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {OrganizationService} from "../../_service/organization.service";
import "rxjs/add/operator/filter";
import {Title} from "@angular/platform-browser";
import "rxjs/add/observable/of";
import {Metrika} from "ng-yandex-metrika";
import {PaySaldoService} from "./pay-saldo.service";

@Component({
  selector: 'app-widget',
  styleUrls: ['../../../css/bootstrap.css', '../bootstrap-select.css'],
  template: '',
  encapsulation: ViewEncapsulation.None
})
export class WidgetComponent implements OnInit, AfterViewInit {
  public addressList: any[];
  public errorMessage: String;
  public selectedItem: any;
  accountNumber: String;
  isRequestCounting = false;
  query: {
    street: any,
    number: String,
    addressId: String,
  };
  public alias;
  public saldo;
  public addressId;


  ngOnInit() {
    this.alias = this.route.snapshot.params.alias;
    // this.organizationService.isAliasExist(this.alias).then(
    //   (isAliasExist) => {
    //     if (!isAliasExist) {
    //       this.router.navigate(['error']);
    //     }
    //   });
    this.accountNumber = this.route.snapshot.queryParams['accountNumber'];
  }

  ngAfterViewInit() {
    console.log('Metrika init');
    let prevPath = this.router.url;
    // this.metrika.;
    this.router
      .events
      .filter(event => (event instanceof NavigationEnd))
      .subscribe(() => {
        const newPath = this.router.url;
        this.metrika.hit(newPath, {
          referer: prevPath,
        });
        console.log('Metrika init');
        prevPath = newPath;
      });
  }

  constructor(private organizationService: OrganizationService,
              private route: ActivatedRoute,
              titleService: Title,
              private paySaldoService: PaySaldoService,
              private router: Router,
              private metrika: Metrika,
              private httpService: HttpService) {
    titleService.setTitle('Лёгкий Платёж ЖКХ');
    this.addressList = [];
    this.accountNumber = '';
    this.query = {
      street: null,
      number: '',
      addressId: '',
    };

    this.alias = this.route.snapshot.pathFromRoot[1].params.alias;
  }

  getAccountState() {
    if (this.selectedItem == null
    // || !this.addressList.map(i => i.text).includes(this.selectedItem.text)
    ) {
      this.errorMessage = 'Введите адрес';
      return;
    }
    if (this.query.number === '') {
      this.errorMessage = 'Введите номер квартиры';
      return;
    }
    if (this.accountNumber === '') {
      this.errorMessage = 'Введите лицевой счет';
      return;
    }
    this.errorMessage = null;
    this.isRequestCounting = true;

    this.paySaldoService.getSaldoDto(
      this.accountNumber,
      this.selectedItem.addressId,
      this.query.number,
      this.alias)
      .then((data) => {
        console.log('Account state is:', data);
        this.errorMessage = null;
        this.saldo = data;
        this.metrika.fireEvent('GET_SALDO');
      }, error => {
        this.errorHandler(error);
      })
      .then(value => {
        this.isRequestCounting = false;

      });
    // const sb = [];
    // sb.push('rest/getAccountState?');
    // sb.push('&accountNumber=' + this.accountNumber.toString());
    // sb.push('&addressId=' + this.selectedItem.addressId);
    // sb.push('&apartmentNumber=' + this.query.number.toString());
    // sb.push('&organizationAlias=' + this.alias);
    //
    // console.log('Address is: ', this.selectedItem);
    // this.httpService.getData(sb.join(''))
    //   .then((data) => {
    //     console.log('Account state is:', data);
    //     this.errorMessage = null;
    //     this.saldo = data;
    //     this.metrika.fireEvent('GET_SALDO');
    //   }, error => {
    //     this.errorHandler(error);
    //   })
    //   .then(value => {
    //     this.isRequestCounting = false;
    //
    //   });
  }

  getBalanceStatus(balance: any) {
    if (balance < 0) {
      return 'К оплате';
    } else if (balance === 0) {
      return 'Баланс';
    } else {
      return 'Переплата';
    }
  }

  select(item) {
    console.log(item);
    this.selectedItem = item;
  }



  refreshValue(value: any): void {
    this.query.street = value;
  }

  resetForm(): void {
    this.saldo = null;
  }

  errorHandler(error: any) {
    this.saldo = null;
    if (error._body.type !== undefined && error._body.type === 'error') {
      this.errorMessage = 'Не удалось связаться с сервисом. Повторите попытку позже.';
    } else {
      this.errorMessage = error._body;
    }
    console.log('Error in get account state: ', error._body);
  }


}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/widget/payment-widget/widget.component.ts